module.exports = __webpack_public_path__ + "static/media/master.dbbe2679.jpeg";